import BaseApi from '@/api/Base/BaseApi'
import { GetVideoResultInformationResponse, GetVideoSegmentScoresResponse, GetVideoSegmentsPayload, GetVideoSegmentsResponse, GetVideoSegmentsSummaryResponse, UpdateIouPayload, UpdateVideoThresholdPayload } from '@/api/VideoResult/types'
import { omitNilOrEmptyStringFromObject } from '@/utils/common'

const ROOT = '/video-results'

export default class VideoResultApi extends BaseApi {
  updateIou(payload: UpdateIouPayload) {
    const { videoResultId, iouTh } = payload
    return this.agent.put(`${ROOT}/${videoResultId}/iou`, { iou_th: iouTh })
  }

  updateThreshold(payload: UpdateVideoThresholdPayload) {
    const { aiJobId, threshold } = payload
    return this.agent.put(`${ROOT}/${aiJobId}/threshold`, { threshold })
  }

  getSegments(payload: GetVideoSegmentsPayload) {
    const { videoResultId, detectionType, page, numPerPage, sortKey, sortDir } = payload
    return this.agent.get<GetVideoSegmentsResponse>(`${ROOT}/${videoResultId}/segments`, {
      params: omitNilOrEmptyStringFromObject({
        detection_type: detectionType,
        page,
        num_per_page: numPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      }),
    })
  }

  getSegmentsSummary(videoResultId: string) {
    return this.agent.get<GetVideoSegmentsSummaryResponse>(`${ROOT}/${videoResultId}/segments-summary`)
  }

  getSegmentScores(videoSegmentId: string) {
    return this.agent.get<GetVideoSegmentScoresResponse>(`/video-segments/${videoSegmentId}/scores`)
  }

  getInformation(aiJobId: string) {
    return this.agent.get<GetVideoResultInformationResponse>(`${ROOT}/${aiJobId}/information`)
  }
}
